var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"human",staticClass:"human",style:({left:_vm.Hleft,bottom:_vm.Hbottom})},[_c('img',{attrs:{"src":_vm.humanPic,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }